import { useMatch } from "react-router-dom";
import { getState } from "@/lib/stateRegistry";

/**
 * The registry entry for the state segment of the current URL, or null on national
 * pages, admin, and unknown slugs. Header, footer, banner and every state page read
 * state from here so there is exactly one source (the URL, validated by the registry).
 */
export default function useCurrentState() {
  const match = useMatch("/:stateSlug/*");
  return match ? getState(match.params.stateSlug) : null;
}
